export default "__VITE_ASSET__CzWRDpet__"